import { useRef, useMemo, useEffect } from 'react';
export function useCancelToken() {
  var cache = useRef(new WeakMap());
  var Token = useMemo(function () {
    return {
      source: function source() {
        var result = {
          cancel: function cancel() {
            return cache.current["delete"](result);
          }
        };
        cache.current.set(result, true);
        return result;
      },
      isCancel: function isCancel(source) {
        return source ? !cache.current.has(source) : false;
      } // eslint-disable-next-line react-hooks/exhaustive-deps

    };
  }, []);
  return Token;
}
export default function useCancelTokenEffect(callback, deep) {
  var cancelToken = useCancelToken();
  useEffect(function () {
    var token = cancelToken.source();
    var result = callback(function () {
      return cancelToken.isCancel(token);
    }, token, cancelToken);
    return function () {
      token.cancel();
      return typeof result === 'function' ? result() : result;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deep);
}